import { createAction } from '@reduxjs/toolkit';

import {
  ActionSuccessType,
  ADMIN_CLEAR_TOKEN,
  ADMIN_REFRESH_TOKEN,
  ADMIN_SIGN_IN_WITH_TOKEN,
} from 'constants/redux-actions';
import { API_ADMIN_REFRESH_TOKEN } from 'constants/api-paths';
import { get, patch } from 'actions/axios-request-actions';

const initAdminClient = () => get('', '', {}, { skipAPI: true, client: 'admin' });

const refreshToken = () => patch(ADMIN_REFRESH_TOKEN, API_ADMIN_REFRESH_TOKEN);
const setCurrentAdmin = (admin) => createAction(ActionSuccessType(ADMIN_SIGN_IN_WITH_TOKEN))({ data: admin });
const clearCurrentAdmin = createAction(ADMIN_CLEAR_TOKEN);

const adminAuthActions = {
  refreshToken,
  initAdminClient,
  setCurrentAdmin,
  clearCurrentAdmin,
};

export default adminAuthActions;
